import { graphql, useMutation } from "react-relay";
import { SetStatusFN } from "./statusCoordinator";
import { useCallback } from "react";
import { useDebouncedMutation } from "../../../../../common/Utils/useDebouncedMutation";
import { useWorkspaceTodoEditSetTitleMutation } from "./__generated__/useWorkspaceTodoEditSetTitleMutation.graphql";

const key = "set_title";
export function useTodoEditSetTitle(
  id: string,
  remoteTitle: string,
  setStatus: SetStatusFN
) {
  const [updateTitle, loading] =
    useMutation<useWorkspaceTodoEditSetTitleMutation>(graphql`
      mutation useWorkspaceTodoEditSetTitleMutation($id: ID!, $title: String!) {
        todoWorkspace(id: $id) {
          updateTitle(newTitle: $title) {
            id
            title
            ...WorkspaceTodoEditMainEditedInfo_Todo
          }
        }
      }
    `);

  const saveTitle = useCallback(
    (title: string) =>
      updateTitle({
        onError: () => setStatus(key, "error"),
        onCompleted: () => setStatus(key, "saved"),
        variables: {
          id,
          title,
        },
      }),
    [id, setStatus, updateTitle]
  );

  return [
    ...useDebouncedMutation(remoteTitle, saveTitle, 500, undefined, () =>
      setStatus(key, "saving")
    ),
    loading,
  ] as const;
}
